export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sellContactImg.b1430c33.svg","height":247,"width":435,"blurWidth":0,"blurHeight":0};